class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button').addEventListener('click', (event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')) {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
        .then((response) => response.text())
        .then((responseText) => {

        });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
      Shopify.getCart((cart) => { window.sharedFunctions?.updateSidebarCart(cart) });
    })
  }
}

customElements.define('coupon-code', CouponCode);

// CTA telemetry: dispatch Microsoft Clarity custom events for every primary CTA,
// and a Klaviyo "Started Checkout" event for cart/drawer checkout clicks.
// Wired via the [data-cta] attribute on each CTA (drawer / cart / pdp).
(function () {
  const TELEMETRY_BUDGET_MS = 1000;

  function trackStartedCheckout(source) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['track', 'Started Checkout', {
          $value: (cart.total_price || 0) / 100,
          ItemCount: cart.item_count,
          ItemNames: (cart.items || []).map((i) => i.title),
          CartSource: source,
        }]);
      });
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise((resolve) => setTimeout(resolve, ms)),
    ]);
  }

  document.addEventListener('click', function (event) {
    // Shopper taps only: the sticky bar adds by clicking the main button from code, and counting that as
    // cta-atc-pdp would change the existing readouts (it has its own atc-sticky).
    if (!event.isTrusted) return;
    const cta = event.target.closest('[data-cta]');
    if (!cta) return;
    const name = cta.getAttribute('data-cta');
    if (!name) return;

    // Respect aria-disabled (e.g. global-checkbox guard on the drawer anchor).
    if (cta.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    if (typeof window.clarity === 'function') {
      try { window.clarity('event', 'cta-' + name); } catch (e) {}
    }

    // Drawer checkout is a plain <a href> with no other handler — intercept,
    // give telemetry a bounded window to land, then navigate. The cart-page
    // checkout already has cart.js holding navigation for ~200ms+ of awaits,
    // so we fire-and-forget there (no preventDefault).
    if (name === 'checkout-drawer') {
      const href = cta.getAttribute('href');
      if (!href || href === '#' || /^javascript:/i.test(href)) return;
      event.preventDefault();
      withTimeout(trackStartedCheckout('drawer').catch(() => {}), TELEMETRY_BUDGET_MS)
        .finally(() => { window.location.assign(href); });
    } else if (name === 'checkout-cart') {
      trackStartedCheckout('cart_page').catch(() => {});
    }
  });
})();